// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1W-5P","loadingShrink":"PageLoading_loadingShrink__3xH0f"};